import styled from 'styled-components';
import { S } from './NewSingUp.style';
import { useNavigate } from 'react-router-dom';
import { PageContainer } from '../components/common/PageComponent.style';
import SocialLogin from '../components/login/SocialLogin';

const SignUp = () => {
  const navigate = useNavigate();
  return (
    <PageContainer>
      <Header>
        <img
          onClick={() => {
            navigate(-1);
          }}
          src="/assets/images/arrow/back-arrow-left-gray.svg"
          alt=""
        />
      </Header>
      <Container>
        <S.Inner>
          <TitleBox>
            <Title>회원가입</Title>
            <Desc>
              손쉽게 시작하는 현명한 투자 <br />
              지금 땅집고옥션에서 시작하세요
            </Desc>
          </TitleBox>
          <ButtonContainer>
            <Button
              onClick={() => {
                navigate('/signupForm');
              }}
            >
              <ButtonIcon
                src="/assets/images/icon/call-outline-blue.svg"
                alt=""
              />
              휴대폰 번호로 시작하기
            </Button>
            <S.SocialLogin>
              <S.LineBox>
                <S.Line />
                <span>소셜 계정으로 간편하게 시작하기</span>
                <S.Line />
              </S.LineBox>
              <SocialLogin />
            </S.SocialLogin>
          </ButtonContainer>
        </S.Inner>
      </Container>
    </PageContainer>
  );
};

export default SignUp;

const Header = styled.div`
  display: flex;
  height: 56px;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
`;

const Container = styled.div`
  display: flex;
  padding: 60px 16px;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  flex-shrink: 0;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

const Title = styled.div`
  align-self: stretch;
  color: #222;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -1.2px;
`;

const Desc = styled.div`
  align-self: stretch;
  color: #616161;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const Button = styled.div`
  position: relative;
  display: flex;
  padding: 14px 16px;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid #008aff;
  background: #fff;

  color: #008aff;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const ButtonIcon = styled.img`
  width: 20px;
  height: 20px;
  aspect-ratio: 1/1;
  position: absolute;
  left: 16px;
  top: 17px;
`;
